"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLACEMENT_MAP = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importStar(require("react"));
require("framer-motion");
const Placement_1 = require("../../values/Placement");
exports.PLACEMENT_MAP = {
    AUTO: Placement_1.PLACEMENT.AUTO,
    TOP: Placement_1.PLACEMENT.TOP,
    RIGHT: Placement_1.PLACEMENT.RIGHT,
    BOTTOM: Placement_1.PLACEMENT.BOTTOM,
    LEFT: Placement_1.PLACEMENT.LEFT,
};
const PopoverTitle = ({ className = '', children }) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `popover-header popover-title ${className}` }, { children: children })));
const PopoverContent = ({ className = '', children }) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `popover-content popover-body ${className}` }, { children: children })));
const isPopoverTitleOrContent = (element) => {
    return (0, react_1.isValidElement)(element) && (element.type === PopoverTitle || element.type === PopoverContent);
};
const Popover = (0, react_1.forwardRef)((props, ref) => {
    const { placement = 'bottom', arrowProps, title, titleClassName = '', contentClassName = '', children, className = '' } = props, remainingProps = tslib_1.__rest(props, ["placement", "arrowProps", "title", "titleClassName", "contentClassName", "children", "className"]);
    const hasTitle = !!title;
    const hasCustomContent = react_1.default.Children.toArray(children).some(isPopoverTitleOrContent);
    // Mount the component but don't show it yet via CSS.
    // After it is mounted, we set the visibility class to use CSS animation
    const [isMounted, setIsMounted] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => setIsMounted(true), []);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({}, remainingProps, { role: 'tooltip', "x-placement": placement, ref: ref, className: `popover fade ${isMounted ? 'show' : ''} ${className}` }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'arrow' }, arrowProps)), hasTitle && (0, jsx_runtime_1.jsx)(PopoverTitle, Object.assign({ className: titleClassName }, { children: title })), hasCustomContent ? children : (0, jsx_runtime_1.jsx)(PopoverContent, Object.assign({ className: contentClassName }, { children: children }))] })));
});
Popover.Title = PopoverTitle;
Popover.Content = PopoverContent;
Object.assign(Popover, exports.PLACEMENT_MAP);
exports.default = Popover;
